var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center align-center full-height"},[_c('v-btn',{attrs:{"title":"Zoom to","x-small":"","color":"primary","icon":""},on:{"click":function($event){return _vm.params.zoomTo(_vm.params.data)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icons.mdiCrosshairs))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }